module.exports = __webpack_public_path__ + "img/couples-043.8d4832ca.jpg";